import React, { useEffect, useState, useMemo, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import "../App.css";
import '../assets/css/gapsybdmupload.css';
import "../assets/Nunito_Sans/static/NotoSansDevanagari-Regular-normal.js";
import "../assets/Nunito_Sans/static/NotoSansDevanagari-Bold-normal.js";
import "../assets/Nunito_Sans/static/DejaVuSans-normal.js";
import '../assets/css/Tableproperty.css';
import { Button, Dropdown, DropdownButton } from 'react-bootstrap';
// import NotoSansNormal from "./NotoSans-Regular-normal.js";
import autoTable from 'jspdf-autotable';
import ExcelJS from 'exceljs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import logoBase64 from '../assets/images/psb.png';
import SloganBase64 from '../assets/images/psb_slogan_hind1i.png';
import { jsPDF } from "jspdf";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Audittemplatelist, AllTemplateColumns, PortURL } from '../components/ApiProperty';
import Header from './gapsy-header';
import Navigation from './gapsy-Cnavigation';
import Footer from './gapsy-footer';
import "bootstrap/dist/css/bootstrap.min.css"
import 'bootstrap-icons/font/bootstrap-icons.css';
import styles from '../assets/css/gapsy-dashboard.module.css';
import DepartmentDropdown from "../components/Dropdown"; // Adjust path based on file location
import { faSort, faSortUp, faSortDown, faListAlt, faFilter } from '@fortawesome/free-solid-svg-icons';
import '../assets/css/gapsycaudit.css';
import tableStyles from '../assets/css/sharedTableStyles.module.css';
import tabStyles from '../assets/css/gapsy-tabs.module.css';


const GapsyReport = () => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('outline'); // 'manual' or 'ai'
    const [filteredTables, setFilteredTables] = useState([]);
    const [selectedPrefix, setSelectedPrefix] = useState("");
    const [loading, setLoading] = useState(false);
    const [npaDescription, setNpaDescription] = useState("");
    const [selectedTable, setSelectedTable] = useState(null);
    const [reportData, setReportData] = useState(null);
    const [tableNames, setTableNames] = useState([]);
    const [currentPage1, setCurrentPage1] = useState(1);
    const [recordsPerPage1] = useState(7); // Set the number of records per page
    const [selectedName, setSelectedName] = useState('');
    const [selectedSector, setSelectedSector] = useState("");
    const [searchQuery, setSearchQuery] = useState('');
    const prefixes = Object.keys(tableNames);
    const [columns, setColumns] = useState([]);
    const [selectedColumns, setSelectedColumns] = useState([]);
    const [availableDates, setAvailableDates] = useState([]);
    const [sumColumns, setSumColumns] = useState([]);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [availableSumColumns, setAvailableSumColumns] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [reportGenerated, setReportGenerated] = useState(false);
    const [tableColumns, setTableColumns] = useState([]);
    const [originalResponseData, setOriginalResponseData] = useState([]);
    const [availableSectors, setAvailableSectors] = useState([]);
    const [sums, setSums] = useState({});
    const [filteredData, setFilteredData] = useState([]);
    const username = localStorage.getItem('username');
    const userRole = localStorage.getItem('userRole');
    const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' });
    const [tempSelectedTable, setTempSelectedTable] = useState('');
    const [processedReports, setProcessedReports] = useState({});
    const [creditRiskTotals, setCreditRiskTotals] = useState({
        RWA: { value: 0, unit: "" },
        CAPITAL: { value: 0, unit: "" }
    });

    const [marketRiskTotals, setMarketRiskTotals] = useState({
        Sum_of_MTM: { value: 0, unit: "" },
        Sum_of_Total: { value: 0, unit: "" }
    });

    const [ifrs9RiskTotals, setifrs9RiskTotals] = useState({
        ECL: { value: 0, unit: "" },
        EAD: { value: 0, unit: "" }
    });

    const [OperationalRiskTotals, setOperationalRiskTotals] = useState({
        Value: { value: 0, unit: "" },
        RWA: { value: 0, unit: "" }
    });

    const [AlmRiskTotals, setAlmRiskTotals] = useState({
        NII: { value: 0, unit: "" },
        EVE: { value: 0, unit: "" }
    });


    const [ifrs9TableData, setIfrs9TableData] = useState([]);

    const [creditRiskData, setCreditRiskData] = useState([]);
    const [showCreditRiskTable, setShowCreditRiskTable] = useState(false);
    const [selectedRiskType, setSelectedRiskType] = useState(null);

    //  Add this state for table configuration
    const [creditRiskTableConfig, setCreditRiskTableConfig] = useState({
        headers: [],
        body: []
    });
    const [marketRiskTableConfig, setMarketRiskTableConfig] = useState({
        headers: [],
        body: []
    });

    const [operationalRiskTableConfig, setOperationalRiskTableConfig] = useState({
        headers: [],
        body: []
    });

    const [almRiskTableConfig, setAlmRiskTableConfig] = useState({
        headers: [],
        body: []
    });

    const department = sessionStorage.getItem("dept");
    console.log("department", department);
    let csrfToken = sessionStorage.getItem("tokenizedSession");

    useEffect(() => {
        fetchData();
    }, []);

    const userId = localStorage.getItem("userid");

    const fetchData = async () => {
        try {

            const config = {
                params: { checkerId: userId, dept: department },
                headers: {
                    'x-csrf-token': csrfToken,
                },
                withCredentials: true
            };

            const response = await axios.post(Audittemplatelist, {}, config);

            console.log("response", response);
            console.log("response.data", response.data);

            const message = "Nothing pending for Upload data";

            if (response.data?.tableList?.length) {
                // Categorize tables by prefix
                const categorizedTables = {};

                response.data.tableList.forEach((table) => {
                    const [prefix, ...rest] = table.split('_');
                    if (!categorizedTables[prefix]) {
                        categorizedTables[prefix] = [];
                    }
                    categorizedTables[prefix].push(table);
                });

                setTableNames(categorizedTables);
            } else {
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        if (selectedPrefix) {
            // Set the filtered tables based on selectedPrefix
            setFilteredTables(tableNames[selectedPrefix] || []);
        } else {
            setFilteredTables([]); // Clear when no prefix is selected
        }
    }, [selectedPrefix, tableNames]);

    const toTitleCase = (str) => {
        return str
            .replace(/[_-]/g, ' ')
            .replace(/([a-z])([A-Z])/g, '$1 $2')
            .replace(/\w\S*/g, (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());
    };

    const filteredRecords1 = useMemo(() => {
        if (!selectedPrefix) return [];

        const query = searchQuery.toLowerCase().trim();
        const filteredTablesForPrefix = tableNames[selectedPrefix] || [];

        return filteredTablesForPrefix.filter((tableName) =>
            tableName.toLowerCase().includes(query)
        );
    }, [tableNames, searchQuery, selectedPrefix]);

    useEffect(() => {
        setCurrentPage1(1);
    }, [searchQuery]);

    useEffect(() => {
        setCurrentPage1(1);
    }, [selectedPrefix]);

    const sortedRecords1 = useMemo(() => {
        return [...filteredRecords1].sort((a, b) => {
            const aStarts = a.toLowerCase().startsWith(searchQuery.toLowerCase());
            const bStarts = b.toLowerCase().startsWith(searchQuery.toLowerCase());
            return bStarts - aStarts;
        });
    }, [filteredRecords1, searchQuery]);

    const indexOfLastRecord = currentPage1 * recordsPerPage1;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage1;
    const currentRecords1 = sortedRecords1.slice(indexOfFirstRecord, indexOfLastRecord);

    const totalPages1 = Math.ceil(sortedRecords1.length / recordsPerPage1);

    const tableDisplayMap = {
        "accounting_override": "Risk Management Dashboard",
        "additional_collateral": "Zone Wise",
        "actcust": "RAM Segment",
        "additional_gl_balance": "Additional GL Balance",
        "distribution_exposure": "Distribution Exposure",
        "exchange_rates": "Exchange Rates",
        "fully_unavailed_tl": "Fully Unavailed TL",
        "investment_depreciationamount": "Investment Depreciation",
        "pf_superannuation": "PF Superannuation",
        "profit_flag": "Profit Flag",
        "rating_override": "Rating Override",
        "restructured_data": "Restructured Data"
    };
    const handleTableChange = async (e) => {
        const selectedFullName = e.target.value;
        setTempSelectedTable(selectedFullName);

        if (!selectedFullName) return;

        // Extract prefix and suffix
        const prefix = selectedFullName.split('_')[0];
        const suffix = selectedFullName.split('_').slice(1).join('_');

        setSelectedPrefix(prefix);
        setSelectedName(suffix);

        // Reset dependent states
        setColumns([]);
        setSelectedColumns([]);
        setTableColumns([]);
        setTableData([]);
        setOriginalResponseData([]);
        setAvailableDates([]);
        setAvailableSectors([]);
        setFromDate("");
        setToDate("");
        setNpaDescription("");
        setSelectedSector('');

        try {
            setLoading(true);

            // Fetch JSON
            const response = await fetch(`/documents/${prefix}.json`);
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            const jsonData = await response.json();
            setReportData(jsonData);

            // Map suffixes to keys
            const suffixToKeyMap = {
                "accounting_override": "sector_report",
                "additional_collateral": "region_report",
                "additional_gl_balance": "zone_report",
                "additional_guarantee": "ramseg_report",
                "balance_sheet": "colendseg_report",
                "balance_sheet_10": "colendretseg_report",
                "balance_sheet_11": "colendmsmeseg_report",
                "balance_sheet_12": "prodewise_bif_vyapar_loan_report",
                "balance_sheet_13": "prodewise_bif_mortgage_loan_report",
                "balance_sheet_14": "prodewise_bif_Mudra_loan_report",
                "balance_sheet_15": "directAsgnmtPool_report",
                "balance_sheet_16": "prodwise_bif_sme_liq_plus_report",
                "balance_sheet_18": "zonewise_bif_report"
            };



            // Process ALL available report types at once
            const processedReports = {};
            const allDates = new Set();
            let allSectors = new Set();

            for (let [keySuffix, jsonKey] of Object.entries(suffixToKeyMap)) {
                if (!jsonData[jsonKey]) continue;

                let flattenedData = [], dates = [], descriptions = [];
                const targetData = jsonData[jsonKey];

                // Call the corresponding process function

                // Normalize column names
                flattenedData = flattenedData.map(row => {
                    const normalized = {};
                    Object.keys(row).forEach(key => {
                        normalized[key.trim()] = row[key];
                    });
                    return normalized;
                });

                // Store processed data
                processedReports[keySuffix] = {
                    flattenedData,
                    dates,
                    descriptions
                };

                // Collect global dates and     sectors
                dates.forEach(d => allDates.add(d));
                flattenedData.forEach(r => allSectors.add(r.Sector));
            }

            // Save processed reports
            setProcessedReports(processedReports);

            const sortedDates = [...allDates].sort();
            if (sortedDates.length >= 2) {
                setFromDate(sortedDates[0]);
                setToDate(sortedDates[sortedDates.length - 1]);
                setReportGenerated(true);
            }

            setAvailableDates(sortedDates);
            setAvailableSectors([...allSectors].sort());

            console.log("Processed Reports:", processedReports);
            console.log("Available Dates:", sortedDates);
            console.log("Available Sectors:", [...allSectors].sort());

        } catch (error) {
            console.error("Error fetching table data:", error);
        } finally {
            setLoading(false);
        }
    };

    // useEffect(() => {
    //     const fetchAndProcess = async () => {
    //         try {
    //             const response = await fetch(`${PortURL}/documents/dashboard.json`);
    //             if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

    //             const jsonData = await response.json();
    //             const creditRiskArray = jsonData.credit_risk || [];
    //             const marketRiskArray = jsonData.market_risk || [];

    //             // Calculate total RWA and CAPITAL
    //             const totalRWA = creditRiskArray.reduce((sum, row) => sum + (row.RWA || 0), 0);
    //             const totalCAPITAL = creditRiskArray.reduce((sum, row) => sum + (row.CAPITAL || 0), 0);

    //             const totalGenericRisk = marketRiskArray.reduce((sum, row) => sum + (row.Sum_of_GENERAL_RISK || 0), 0);
    //             const totalSpecificRisk = marketRiskArray.reduce((sum, row) => sum + (row.Sum_of_SPECIFIC_RISK || 0), 0);
    //             // Convert to Billions
    //             const totalGenericRiskInBillions = (totalGenericRisk / 1e9).toFixed(2);
    //             const totalSpecificRiskBillions = (totalSpecificRisk / 1e9).toFixed(2);

    //             const totalRWAInBillions = (totalRWA / 1e9).toFixed(2);
    //             const totalCAPITALInBillions = (totalCAPITAL / 1e9).toFixed(2);

    //             setCreditRiskTotals({
    //                 RWA: totalRWAInBillions,
    //                 CAPITAL: totalCAPITALInBillions
    //             });

    //             setMarketRiskTotals({
    //                 RWA: totalGenericRiskInBillions,
    //                 CAPITAL: totalSpecificRiskBillions
    //             });

    //             // Define table headers and store body dynamically
    //             const tableHeaders = [
    //                 { key: "COUNTERPARTY_CLASS", label: "COUNTERPARTY CLASS" },
    //                 { key: "COUNTERPARTY_SUBCLASS", label: "COUNTERPARTY SUBCLASS" },
    //                 { key: "EXP_VAL", label: "EXPOSURE VALUE" },
    //                 { key: "CAPITAL", label: "CAPITAL" },
    //                 { key: "RWA", label: "RWA" },
    //                 { key: "EAD", label: "EAD" }
    //             ];
    //             const tableHeaders1 = [
    //                 { key: "Sum_of_MTM", label: "Sum_of_MTM" },
    //                 { key: "PRODUCT_SUBTYPE", label: "PRODUCT_SUBTYPE" },
    //                 { key: "Sum_of_GENERAL_RISK", label: "Sum_of_GENERAL_RISK" },
    //                 { key: "Sum_of_SPECIFIC_RISK", label: "Sum_of_SPECIFIC_RISK" }

    //             ];

    //             setCreditRiskTableConfig({
    //                 headers: tableHeaders,
    //                 body: creditRiskArray
    //             });
    //             setMarketRiskTableConfig({
    //                 headers: tableHeaders1,
    //                 body: marketRiskArray
    //             });

    //         } catch (error) {
    //             console.error("Error fetching or processing data:", error);
    //         }
    //     };

    //     fetchAndProcess();
    // }, []);

    const processIFRS9 = (ifrs9Array) => {
        if (!ifrs9Array || ifrs9Array.length === 0) return [];

        const grouped = {};
        let totalEAD = 0; // collect EAD separately

        ifrs9Array.forEach((row) => {
            const { Balance_Type, Counterparty_class, ECL_Stage, sum_ecl, sum_ead } = row;

            // ✅ Handle EAD row
            if (sum_ead !== undefined) {
                totalEAD += sum_ead;
                return; // skip further processing
            }

            // ✅ Skip invalid rows
            if (!Balance_Type || !Counterparty_class || !ECL_Stage) return;

            if (!grouped[Balance_Type]) grouped[Balance_Type] = {};
            if (!grouped[Balance_Type][Counterparty_class]) {
                grouped[Balance_Type][Counterparty_class] = {
                    Stage_1: 0,
                    Stage_2: 0,
                    Stage_3: 0,
                    Total: 0
                };
            }

            const stageKey = ECL_Stage.replace(" ", "_"); // "Stage 1" → "Stage_1"
            if (grouped[Balance_Type][Counterparty_class][stageKey] !== undefined) {
                grouped[Balance_Type][Counterparty_class][stageKey] += sum_ecl;
            }
            grouped[Balance_Type][Counterparty_class].Total += sum_ecl;
        });

        const balanceTypeOrder = ["On Balance Sheet", "Off Balance Sheet"];
        const result = [];

        balanceTypeOrder.forEach((balanceType) => {
            if (!grouped[balanceType]) return;

            // Header row
            result.push({
                Financial_Asset: balanceType,
                Stage_1: null,
                Stage_2: null,
                Stage_3: null,
                Total: null,
                isHeader: true
            });

            // Totals row
            let balanceTotals = { Stage_1: 0, Stage_2: 0, Stage_3: 0, Total: 0 };
            Object.values(grouped[balanceType]).forEach((entry) => {
                balanceTotals.Stage_1 += entry.Stage_1;
                balanceTotals.Stage_2 += entry.Stage_2;
                balanceTotals.Stage_3 += entry.Stage_3;
                balanceTotals.Total += entry.Total;
            });

            result.push({
                Financial_Asset: balanceType,
                ...balanceTotals,
                isTotal: true
            });

            // Counterparty rows
            Object.keys(grouped[balanceType]).forEach((cp) => {
                result.push({
                    Financial_Asset: cp,
                    ...grouped[balanceType][cp]
                });
            });
        });

        // ✅ If you want to display EAD as a separate row at the bottom


        return result;
    };

    // Helper: formats a number into Thousands / Lakhs / Millions / Billions dynamically
    // Fixed formatter by unit
    const formatByUnit = (num, unit) => {
        if (num === null || num === undefined || isNaN(num)) {
            return { value: 0, unit: "" };
        }

        switch (unit) {
            case "billions":
                return { value: (num / 1e9).toFixed(2), unit: "B" };
            case "millions":
                return { value: (num / 1e6).toFixed(2), unit: "M" };
            default:
                return { value: num.toFixed(2), unit: "" };
        }
    };

    const unitByRiskType = {
        credit_risk: "billions",
        ifrs9: "millions",
        market_risk: "millions",
        operational_risk: "millions",
        alm: "millions"
    };

    const unitSymbol = {
        billions: "B",
        millions: "M",
    };



    useEffect(() => {
        const fetchAndProcess = async () => {
            try {
                const response = await fetch(`/documents/dashboard_combined.json`);
                if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

                const jsonData = await response.json();

                // const creditRiskArray = jsonData.Cr_report || [];
                // ---- Credit Risk Sorting ----
                const creditRiskArray = (jsonData.Cr_report || []).sort((a, b) => {
                    // Primary: Counterparty Class
                    if (a.COUNTERPARTY_CLASS < b.COUNTERPARTY_CLASS) return -1;
                    if (a.COUNTERPARTY_CLASS > b.COUNTERPARTY_CLASS) return 1;

                    // Secondary: Counterparty Subclass
                    if (a.COUNTERPARTY_SUBCLASS < b.COUNTERPARTY_SUBCLASS) return -1;
                    if (a.COUNTERPARTY_SUBCLASS > b.COUNTERPARTY_SUBCLASS) return 1;

                    return 0;
                });

                // const marketRiskArray = jsonData.Mr_report || [];
                const marketRiskArray = (jsonData.Mr_report || []).map(row => ({
                    ...row,
                    Capital: (row.Sum_of_GENERAL_RISK || 0) + (row.Sum_of_SPECIFIC_RISK || 0)
                }));

                const ifrs9RiskArray = jsonData.Ifrs9_report || [];
                // const OperationalRiskArray = jsonData.Or_report || [];
                const OperationalRiskArray = (jsonData.Or_report || []).map(row => {
                    const capitalCharge = (row.component_value || 0) * (row.internal_loss_multiplier || 0);
                    return {
                        ...row,
                        Capital_Charge: capitalCharge,
                        Weighted_Assets: capitalCharge * 12.5
                    };
                });

                const AlmRiskArray = jsonData.Alm_report || [];

                // ---- Totals for Credit Risk ----
                const totalRWA = creditRiskArray.reduce((sum, row) => sum + (row.RWA || 0), 0);
                const totalCAPITAL = creditRiskArray.reduce((sum, row) => sum + (row.CAPITAL || 0), 0);

                const totalValues = OperationalRiskArray.reduce((sum, row) => sum + (row.value || 0), 0);

                const totalRWAValue = OperationalRiskArray.reduce((sum, row) => sum + (row.value || 0) * 12.5, 0);

                const NIIValue = AlmRiskArray.find(row => row.Component_Name === "NII")?.Capital_Requirement || 0;
                const EVEValue = AlmRiskArray.find(row => row.Component_Name === "EVE")?.Capital_Requirement || 0;

                console.log("NIIValue", NIIValue);
                console.log("EVEValue", EVEValue);

                const totalECL = ifrs9RiskArray.reduce((sum, row) => sum + (row.sum_ecl || 0), 0);
                console.log("totalECL", totalECL);
                const totalEAD = ifrs9RiskArray.reduce((sum, row) => sum + (row.sum_ead || 0), 0);

                const totalGenericRisk = marketRiskArray.reduce(
                    (sum, row) => sum + (row.Sum_of_MTM || 0),
                    0
                );

                const totalCapital = marketRiskArray.reduce(
                    (sum, row) => sum + (row.Capital || 0),
                    0
                );
                setCreditRiskTotals({
                    RWA: formatByUnit(totalRWA, unitByRiskType.credit_risk),
                    CAPITAL: formatByUnit(totalCAPITAL, unitByRiskType.credit_risk),
                });

                setifrs9RiskTotals({
                    ECL: formatByUnit(totalECL, unitByRiskType.ifrs9),
                    EAD: formatByUnit(totalEAD, unitByRiskType.ifrs9),
                });

                setMarketRiskTotals({
                    Sum_of_MTM: formatByUnit(totalGenericRisk, unitByRiskType.market_risk),
                    Sum_of_Total: formatByUnit(totalCapital, unitByRiskType.market_risk) // ✅ matches UI expectation
                });

                setOperationalRiskTotals({
                    Value: formatByUnit(totalValues, unitByRiskType.operational_risk),
                    RWA: formatByUnit(totalRWAValue, unitByRiskType.operational_risk)
                });

                setAlmRiskTotals({
                    NII: formatByUnit(NIIValue, unitByRiskType.alm),
                    EVE: formatByUnit(EVEValue, unitByRiskType.alm)
                });

                // ---- Dynamic Headers ----
                const getHeadersFromData = (dataArray) => {
                    if (dataArray.length === 0) return [];
                    return Object.keys(dataArray[0]).map((key) => ({
                        key,
                        label: key.replace(/_/g, " ").toUpperCase()
                    }));
                };

                const creditRiskHeaders = [
                    { key: "COUNTERPARTY_CLASS", label: "COUNTERPARTY CLASS" },
                    { key: "COUNTERPARTY_SUBCLASS", label: "COUNTERPARTY SUBCLASS" },
                    { key: "EXPOSURE_VALUE", label: "EXPOSURE VALUE" },
                    { key: "EAD", label: "EAD" },
                    { key: "RWA", label: "RWA" },
                    { key: "CAPITAL", label: "CAPITAL" }

                ];

                const marketRiskHeaders = [
                    { key: "PRODUCT_SUBTYPE", label: "PRODUCT SUBTYPE" },
                    { key: "Sum_of_MTM", label: "MTM" },
                    { key: "Sum_of_GENERAL_RISK", label: "GENERAL RISK" },
                    { key: "Sum_of_SPECIFIC_RISK", label: "SPECIFIC RISK" },
                    { key: "Capital", label: "CAPITAL" } // new column
                ];


                const OperationalRiskHeaders = [
                    { key: "component", label: "COMPONENT" },
                    { key: "value", label: "VALUE" }
                ];


                setCreditRiskTableConfig({
                    headers: creditRiskHeaders,
                    body: creditRiskArray
                });

                setMarketRiskTableConfig({
                    headers: marketRiskHeaders,
                    body: marketRiskArray
                });

                setOperationalRiskTableConfig({
                    headers: OperationalRiskHeaders,
                    body: OperationalRiskArray
                });

                setAlmRiskTableConfig({
                    headers: getHeadersFromData(AlmRiskArray),
                    body: AlmRiskArray
                });

                const ifrs9Array = jsonData.Ifrs9_report || [];
                const processedIFRS9 = processIFRS9(ifrs9Array);
                setIfrs9TableData(processedIFRS9);


            } catch (error) {
                console.error("Error fetching or processing data:", error);
            }
        };

        fetchAndProcess();
    }, []);


    const generateReport = () => {
        if (!fromDate || !toDate || !processedReports) {
            setTableData([]);
            setNpaDescription("");
            setReportGenerated(false);
            return;
        }

        const selectedDates = [fromDate, toDate];
        const report = processedReports[selectedName];

        if (!report) {
            console.warn("No report data found for selected type:", selectedName);
            setTableData([]);
            setNpaDescription("No data available for this report.");
            return;
        }

        let { flattenedData, descriptions } = report;

        let filtered = flattenedData
            .filter(row => selectedDates.includes(row.Date))
            .sort((a, b) => new Date(a.Date) - new Date(b.Date));

        if (selectedSector) {
            filtered = filtered.filter(row => row.Sector === selectedSector);
        }

        setTableData(filtered);

        const descText = descriptions.length
            ? descriptions.join(" ")
            : `No significant changes observed for ${selectedName.replace("_", " ")} during the selected period.`;

        setNpaDescription(descText);

        console.log("Filtered Table Data:", filtered);
        console.log("NPA Description:", descText);

        setReportGenerated(true);
    };

    //  This will ONLY run when report is already generated
    useEffect(() => {
        if (!reportGenerated) return;

        const selectedDates = [fromDate, toDate];

        let filtered = originalResponseData
            .filter(row => selectedDates.includes(row.Date))
            .sort((a, b) => new Date(a.Date) - new Date(b.Date));

        if (selectedSector) {
            filtered = filtered.filter(row => row.Sector === selectedSector);
        }

        setTableData(filtered);
    }, [selectedSector]);


    const handleDashboard = () => {
        navigate("/gapsyCdashboard");
    };

    let rowTotal = 0;
    return (
        <div className={`d-flex flex-column min-vh-100 ${styles.pageFullBackground}`}>
            <Header />
            <Navigation />
            <div className="top-0 px-4 py-1 text-white">
                <div className="d-flex justify-content-between align-items-center flex-wrap">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-1">
                                <li className={`breadcrumb-item ${styles.breadcrumbItem}`}>
                                    <a onClick={handleDashboard} className={`text-dark ${styles.breadcrumbLink}`}>
                                        <i className="bi bi-house me-2" style={{ cursor: "pointer" }}></i>
                                    </a>
                                    <span className={styles.separator}>/</span>
                                </li>
                                <li className={`breadcrumb-item active ${styles.breadcrumbItem}`} aria-current="page">
                                    <i className="bi bi-file-richtext me-2"></i> Risk Management Report
                                </li>
                            </ol>
                        </nav>
                    </div>

                </div>
            </div>
            <main className="flex-grow-1 container-fluid">
                <div className={styles.mainContainer}>
                    <div className="container-fluid">
                        <div className="row">
                            {/* left side Column code */}

                            {/* right Column with Table */}
                            {/* {reportGenerated && tableData.length > 0 && ( */}
                            {/* <div className="col-lg-12 col-md-12"> */}
                                <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                                    <div className="card-body d-flex flex-column">
                                        <div className="container">

                                        <div className="d-flex align-items-center justify-content-between mb-1">
                                                <h4 className="fw-bold mb-0">
                                                    Risk Management Dashboard
                                                    {selectedRiskType && ` - ${selectedRiskType.replace("_", " ").toUpperCase()}`}
                                                </h4>
                                                {selectedRiskType && (
                                                    <i
                                                        className="bi bi-arrow-left fs-5"
                                                        style={{ cursor: "pointer" }}
                                                        onClick={() => setSelectedRiskType(null)}
                                                    ></i>
                                                )}
                                            </div>



                                            {!selectedRiskType ? (
                                                <p className="text-muted">
                                                Comprehensive overview of Enterprise Risk Metrics and Compliance status
                                                </p>
                                            ) : null}

                                            {!selectedRiskType ? (
                                            <div className="row g-3">
                                                    {/* Credit Risk */}
                                                    <div className="col-md-4" onClick={() => setSelectedRiskType("credit_risk")}>
                                                        <div className="risk-card card shadow-sm border-0 rounded-4 overflow-hidden">
                                                            <div className="risk-header credit-risk d-flex align-items-center p-2">
                                                                <i className="bi bi-cash-stack me-2 fs-5 text-white risk-icon"></i>
                                                                <h6 className="mb-0 fw-bold text-white">Credit Risk</h6>
                                                            </div>
                                                            <div className="risk-divider"></div>
                                                            <div className="risk-body p-2">
                                                                <p className="small text-muted mb-1">
                                                                Computation of Risk Weighted Assets and Capital adequacy in line with Regulatory standards.
                                                                </p>
                                                                <div className="risk-divider"></div>
                                                                <div className="d-flex justify-content-between fw-semibold mt-2">
                                                                    <div><strong>{creditRiskTotals.RWA.value} {creditRiskTotals.RWA.unit}</strong><br /><small>RWA</small></div>
                                                                    <div><strong>{creditRiskTotals.CAPITAL.value} {creditRiskTotals.CAPITAL.unit}</strong><br /><small>CAPITAL</small></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-4" onClick={() => setSelectedRiskType("market_risk")}>
                                                        <div className="risk-card card shadow-sm border-0 rounded-4 overflow-hidden">
                                                            <div className="risk-header market-risk d-flex align-items-center p-2">
                                                                <i className="bi bi-graph-up-arrow me-2 fs-5 text-white risk-icon"></i>
                                                                <h6 className="mb-0 fw-bold text-white">Market Risk</h6>
                                                            </div>
                                                            <div className="risk-divider"></div>
                                                            <div className="risk-body p-2">
                                                                <p className="small text-muted mb-1">
                                                                Mark-to-Market valuation of exposures and computation of Capital requirements under Regulatory guidelines.
                                                                </p>
                                                                <div className="risk-divider"></div>
                                                                <div className="d-flex justify-content-between fw-semibold mt-2">
                                                                    <div><strong>{marketRiskTotals.Sum_of_MTM.value} {marketRiskTotals.Sum_of_MTM.unit}</strong><br /><small>MTM</small></div>
                                                                    <div><strong>{marketRiskTotals.Sum_of_Total.value} {marketRiskTotals.Sum_of_Total.unit}</strong><br /><small>CAPITAL</small></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Operational Risk */}
                                                    <div className="col-md-4" onClick={() => setSelectedRiskType("operational_risk")}>
                                                        <div className="risk-card card shadow-sm border-0 rounded-4 overflow-hidden">
                                                            <div className="risk-header op-risk d-flex align-items-center p-2">
                                                                <i className="bi bi-gear-wide-connected me-2 fs-5 text-white risk-icon"></i>
                                                                <h6 className="mb-0 fw-bold text-white">Operational Risk</h6>
                                                            </div>
                                                            <div className="risk-divider"></div>
                                                            <div className="risk-body p-2">
                                                                <p className="small text-muted mb-1">
                                                                Computation of Capital requirements and Risk-Weighted Assets in line with regulatory standards.
                                                                </p>
                                                                <div className="risk-divider"></div>
                                                                <div className="d-flex justify-content-between fw-semibold mt-2">
                                                                    <div><strong>{OperationalRiskTotals.Value.value} {OperationalRiskTotals.Value.unit}</strong><br /><small>CAPITAL</small></div>
                                                                    <div><strong>{OperationalRiskTotals.RWA.value} {OperationalRiskTotals.RWA.unit}</strong><br /><small>RWA</small></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Market Risk */}


                                                    {/* Liquidity Risk */}
                                                    <div className="col-md-4" onClick={() => setSelectedRiskType("ifrs9")}>
                                                        <div className="risk-card card shadow-sm border-0 rounded-4 overflow-hidden">
                                                            <div className="risk-header liq-risk d-flex align-items-center p-2">
                                                                <i className="bi bi-droplet me-2 fs-5 text-white risk-icon"></i>
                                                                <h6 className="mb-0 fw-bold text-white">IFRS9</h6>
                                                            </div>
                                                            <div className="risk-divider"></div>
                                                            <div className="risk-body p-2">
                                                                <p className="small text-muted mb-1">
                                                                Computation of Exposure at Default and Expected Credit Loss in line with IFRS 9 requirements.
                                                                </p>
                                                                <div className="risk-divider"></div>
                                                                <div className="d-flex justify-content-between fw-semibold mt-2">
                                                                    <div><strong>{ifrs9RiskTotals.EAD.value} {ifrs9RiskTotals.EAD.unit}</strong><br /><small>EAD</small></div>
                                                                    <div><strong>{ifrs9RiskTotals.ECL.value} {ifrs9RiskTotals.ECL.unit}</strong><br /><small>ECL</small></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* ICAAP */}
                                                    <div className="col-md-4" onClick={() => setSelectedRiskType("alm")}>
                                                        <div className="risk-card card shadow-sm border-0 rounded-4 overflow-hidden">
                                                            <div className="risk-header ilaap-risk d-flex align-items-center p-2">
                                                                <i className="bi bi-pie-chart-fill me-2 fs-5 text-white risk-icon"></i>
                                                                <h6 className="mb-0 fw-bold text-white">ALM</h6>
                                                            </div>
                                                            <div className="risk-divider"></div>
                                                            <div className="risk-body p-2">
                                                                <p className="small text-muted mb-1">
                                                                Net Interest Income (NII) and Economic Value of Equity (EVE) assessments supporting Capital planning and Balance Sheet management strategies.
                                                                </p>
                                                                <div className="risk-divider"></div>
                                                                <div className="d-flex justify-content-between fw-semibold mt-2">
                                                                    <div><strong>{AlmRiskTotals.NII.value} {AlmRiskTotals.NII.unit}</strong><br /><small>NII</small></div>
                                                                    <div><strong>{AlmRiskTotals.EVE.value} {AlmRiskTotals.EVE.unit}</strong><br /><small>EVE</small></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* ILAAP */}


                                                </div>
                                            ) : (
                                                <div>
                                                    {/* <h5>{selectedRiskType.replace("_", " ").toUpperCase()} Details</h5> */}

                                                    <div className="d-flex justify-content-end mb-2">
                                                        <span className="text-sm text-gray-600">
                                                            (Values in {unitByRiskType[selectedRiskType].charAt(0).toUpperCase() + unitByRiskType[selectedRiskType].slice(1)})
                                                        </span>
                                                    </div>
                                                    <div className="table-on-homepage-only">
                                                        <div className={`tableWrapper ${tableStyles.tableWrapper}`}>
                                                            <table
                                                                className={`table table-bordered table-hover text-center customScrollTable ${tableStyles.customScrollTable}`}
                                                            >
                                                                <thead>
                                                                    {selectedRiskType === "ifrs9" ? (
                                                                        <>
                                                                            <tr>
                                                                                <th
                                                                                    rowSpan={2}
                                                                                    style={{
                                                                                        verticalAlign: "middle",
                                                                                        position: "sticky",
                                                                                        top: 0,
                                                                                        background: "#f1f1f1",
                                                                                        zIndex: 2,
                                                                                    }}
                                                                                >
                                                                                    FINANCIAL ASSET
                                                                                </th>
                                                                                <th
                                                                                    colSpan={4}
                                                                                    style={{
                                                                                        position: "sticky",
                                                                                        top: 0,
                                                                                        background: "#f1f1f1",
                                                                                        zIndex: 2,
                                                                                    }}
                                                                                >
                                                                                    ECL BREAKDOWN
                                                                                </th>
                                                                            </tr>
                                                                            <tr>
                                                                                <th
                                                                                    style={{
                                                                                        position: "sticky",
                                                                                        top: "35px",
                                                                                        background: "#f1f1f1",
                                                                                        zIndex: 2,
                                                                                    }}
                                                                                >
                                                                                Stage 1
                                                                                </th>
                                                                                <th
                                                                                    style={{
                                                                                        position: "sticky",
                                                                                        top: "35px",
                                                                                        background: "#f1f1f1",
                                                                                        zIndex: 2,
                                                                                    }}
                                                                                >
                                                                                Stage 2
                                                                                </th>
                                                                                <th
                                                                                    style={{
                                                                                        position: "sticky",
                                                                                        top: "35px",
                                                                                        background: "#f1f1f1",
                                                                                        zIndex: 2,
                                                                                    }}
                                                                                >
                                                                                Stage 3
                                                                                </th>
                                                                                <th
                                                                                    style={{
                                                                                        position: "sticky",
                                                                                        top: "35px",
                                                                                        background: "#f1f1f1",
                                                                                        zIndex: 2,
                                                                                    }}
                                                                                >
                                                                                    Total
                                                                                </th>
                                                                            </tr>
                                                                        </>
                                                                    ) : (
                                                                        <tr>
                                                                        {(
                                                                            selectedRiskType === "credit_risk"
                                                                                ? creditRiskTableConfig.headers
                                                                                : selectedRiskType === "operational_risk"
                                                                                    ? operationalRiskTableConfig.headers
                                                                                    : selectedRiskType === "alm"
                                                                                        ? almRiskTableConfig.headers
                                                                                        : marketRiskTableConfig.headers
                                                                            ).map((col, idx) => (
                                                                                <th key={idx}>{col.label}</th>
                                                                            ))}
                                                                        </tr>
                                                                    )}
                                                                </thead>

                                                                <tbody>
                                                                    {selectedRiskType === "ifrs9" ? (
                                                                    <>
                                                                        {ifrs9TableData.map((row, idx) =>
                                                                            row.isHeader ? (
                                                                                <tr key={idx}></tr>
                                                                            ) : (
                                                                                <tr
                                                                                    key={idx}
                                                                                    className={row.isTotal ? "ifrs9-total-row" : ""}
                                                                                >
                                                                                    <td>{row.Financial_Asset}</td>
                                                                                    <td>
                                                                                        {row.Stage_1
                                                                                            ? formatByUnit(row.Stage_1, unitByRiskType[selectedRiskType]).value
                                                                                            : "-"}
                                                                                    </td>
                                                                                    <td>
                                                                                        {row.Stage_2
                                                                                            ? formatByUnit(row.Stage_2, unitByRiskType[selectedRiskType]).value
                                                                                            : "-"}
                                                                                    </td>
                                                                                    <td>
                                                                                        {row.Stage_3
                                                                                            ? formatByUnit(row.Stage_3, unitByRiskType[selectedRiskType]).value
                                                                                            : "-"}
                                                                                    </td>
                                                                                    <td>
                                                                                        {row.Total
                                                                                            ? formatByUnit(row.Total, unitByRiskType[selectedRiskType]).value
                                                                                            : "-"}
                                                                                    </td>
                                                                                </tr>
                                                                            )
                                                                        )}

                                                                        {/* ❌ Removed IFRS9 bottom total row */}
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        {/* Non-IFRS9 tables still render their total row */}
                                                                        {(
                                                                            selectedRiskType === "credit_risk"
                                                                                ? creditRiskTableConfig.body
                                                                                : selectedRiskType === "operational_risk"
                                                                                    ? operationalRiskTableConfig.body
                                                                                    : selectedRiskType === "alm"
                                                                                        ? almRiskTableConfig.body
                                                                                    : marketRiskTableConfig.body
                                                                        ).map((row, idx) => {
                                                                            const headers =
                                                                                selectedRiskType === "credit_risk"
                                                                                    ? creditRiskTableConfig.headers
                                                                                    : selectedRiskType === "operational_risk"
                                                                                        ? operationalRiskTableConfig.headers
                                                                                        : selectedRiskType === "alm"
                                                                                            ? almRiskTableConfig.headers
                                                                                            : marketRiskTableConfig.headers;

                                                                            return (
                                                                            <tr key={idx}>
                                                                                    {headers.map((col, cIdx) => {
                                                                                    let value = row[col.key];
                                                                                    if (typeof value === "number" && !isNaN(value)) {
                                                                                            value = formatByUnit(value, unitByRiskType[selectedRiskType]).value;
                                                                                    }
                                                                                    return <td key={cIdx}>{value || "-"}</td>;
                                                                                })}
                                                                            </tr>
                                                                            );
                                                                        })}

                                                                        {/* ✅ Keep total row only for non-IFRS9 */}
                                                                        {selectedRiskType === "operational_risk" ? (
                                                                            <>
                                                                                {/* Capital Charge */}
                                                                                <tr>
                                                                                    <td>Operational Risk Capital Charge</td>
                                                                                    <td colSpan={operationalRiskTableConfig.headers.length - 1}>
                                                                                        {(() => {
                                                                                            const totalCapitalCharge = operationalRiskTableConfig.body.reduce(
                                                                                                (sum, row) =>
                                                                                                    sum + (row.value || 0) * (row.internal_loss_multiplier || 1),
                                                                                                0
                                                                                            );
                                                                                            return formatByUnit(totalCapitalCharge, unitByRiskType.operational_risk).value;
                                                                                        })()}
                                                                                    </td>
                                                                                </tr>

                                                                                {/* Weighted Assets */}
                                                                                <tr>
                                                                                    <td>Operational Risk Weighted Assets</td>
                                                                                    <td colSpan={operationalRiskTableConfig.headers.length - 1}>
                                                                                        {(() => {
                                                                                            const totalCapitalCharge = operationalRiskTableConfig.body.reduce(
                                                                                                (sum, row) =>
                                                                                                    sum + (row.value || 0) * (row.internal_loss_multiplier || 1),
                                                                                                0
                                                                                            );
                                                                                            const weightedAssets = totalCapitalCharge * 12.5;
                                                                                            return formatByUnit(weightedAssets, unitByRiskType.operational_risk).value;
                                                                                        })()}
                                                                                    </td>
                                                                                </tr>

                                                                             
                                                                            </>
                                                                        ) : (
                                                                            // <tr className="grand-total-row" style={{ fontWeight: "bold" }}>
                                                                            <tr
                                                                                className="grand-total-row"
                                                                                style={{
                                                                                    position: "sticky",
                                                                                    bottom: 0,
                                                                                    background: "#f1f1f1",
                                                                                    fontWeight: "bold",
                                                                                    zIndex: 5
                                                                                }}
                                                                            >

                                                                                {(() => {
                                                                                    const headers =
                                                                                        selectedRiskType === "credit_risk"
                                                                                            ? creditRiskTableConfig.headers
                                                                                            : selectedRiskType === "alm"
                                                                                                ? almRiskTableConfig.headers
                                                                                                : marketRiskTableConfig.headers;

                                                                                    const body =
                                                                                        selectedRiskType === "credit_risk"
                                                                                            ? creditRiskTableConfig.body
                                                                                            : selectedRiskType === "alm"
                                                                                                ? almRiskTableConfig.body
                                                                                                : marketRiskTableConfig.body;

                                                                                    return (
                                                                                        <>
                                                                                            <td className="non-ifrs9-total-cell">Total</td>
                                                                                            {headers.slice(1).map((col, idx) => {
                                                                                                const sum = body.reduce(
                                                                                                    (acc, row) =>
                                                                                                        acc +
                                                                                                        (typeof row[col.key] === "number" ? row[col.key] : 0),
                                                                                                    0
                                                                                                );
                                                                                                return (
                                                                                                    <td className="non-ifrs9-total-cell" key={idx}>
                                                                                                        {sum
                                                                                                            ? formatByUnit(sum, unitByRiskType[selectedRiskType]).value
                                                                                                            : "-"}
                                                                                                    </td>
                                                                                                );
                                                                                            })}
                                                                                        </>
                                                                                    );
                                                                                })()}
                                                                            </tr>
                                                                        )}
                                                                    </>
                                                                    )}
                                                                </tbody>


                                                            </table>

                                                        </div>
                                                    </div>
                                                </div>
                                            )}





                                            <style jsx>{`
    .row.g-4 {
      display: flex;
      flex-wrap: wrap;
    }
    .col-md-3 {
      display: flex;
    }
    .risk-card {
      flex: 1;
      display: flex;
      flex-direction: column;
      background: #fff;
      transition: transform 0.3s ease, box-shadow 0.3s ease;
      cursor: pointer;
    }
    .risk-divider {
      border-bottom: 2px solid #e0e0e0;
    }
    .risk-body {
      flex: 1;
    }
    .risk-body p {
      min-height: 41px; /* same line alignment */
    }
    .risk-card:hover {
      transform: translateY(-4px);
      box-shadow: 0 10px 25px rgba(0,0,0,0.1);
    }
    .risk-icon {
      transition: transform 0.3s ease, color 0.3s ease;
    }
    .risk-card:hover .risk-icon {
      transform: scale(1.2);
      color: #ffc107;
    }

    /* Background Variations */
    .reg-risk,
    .credit-risk,
    .liq-risk {
     background: linear-gradient(90deg, #2C415A, #827394);  /* teal-purple */
    }
     
    .icaap-risk {
      background: linear-gradient(90deg, #E3BC60, #998396); /* green-purple */
    }
    
    .op-risk {
      background: linear-gradient(90deg, #D1675F, #967996); /* blue shades */
    }
      .ilaap-risk ,
    .market-risk {
       background: linear-gradient(90deg, #E3BC60, #998396); /* blue shades */
    }
  `}</style>
                                        </div>

                                    </div>
                                </div>

                                {/* Hover & blink CSS (scoped to this component) */}


                            {/* </div> */}

                            {/* )} */}
                        </div>
                    </div>
                </div>
            </main >
            <Footer />
        </div >
    );

}

export default GapsyReport;
